import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import moment from 'moment'
import { observable} from 'mobx'

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from '../Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoIntellectual extends Component {
    @observable to_date = null

    componentWillMount() {
        this.initializeState()
      }
    
      initializeState() {
        if (this.props.to_date) {
          this.to_date = moment(this.props.to_date, 'YYYY-MM-DD')
        }
      }
    
    render() {
        const { intellectual: items } = this.props;
        const summary = getTitleSummary(items)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Объекты интеллектуальной собственности'],
                    rows: summary
                }}
                expanded={false}
                table={{
                    headers: [
                        'Код',
                        'Рег.номер',
                        'Наименование',
                        'Правообладатель',
                        'Классы по МКТУ',
                        'Дата окончания регистрации',
                        'Нормативный документ'
                    ],
                    rows: items.map(({ to_date = null, code = '', number = '', name='', mktu='', company_name = '',  order, order_date, orders_info }) => ([
                        <Code code={code} />,
                        number,
                        name,
                        company_name,
                        mktu,
                        to_date !== null ? to_date.split("-").reverse().join(".") : '',
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}


function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}







// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoIntellectual.js